import { Group, GroupArgs, GroupEntry, GroupEntryArgs } from "@depmap/types";
import { uri } from "../../uriTemplateTag";
import { getJson, postJson, deleteJson } from "../client";

export function getGroups(write_access: boolean = false) {
  return getJson<Group[]>("/groups/", { write_access });
}

export function postGroup(groupArgs: GroupArgs) {
  return postJson<Group>("/groups/", groupArgs);
}

export function deleteGroup(id: string) {
  return deleteJson<{ message: string }>(uri`/groups/${id}`);
}

export function postGroupEntry(
  groupId: string,
  groupEntryArgs: GroupEntryArgs
) {
  return postJson<GroupEntry>(
    uri`/groups/${groupId}/addAccess`,
    groupEntryArgs
  );
}

export function deleteGroupEntry(groupEntryId: string) {
  return deleteJson(uri`/groups/${groupEntryId}/removeAccess`, {
    groupEntryId,
  });
}
